export default __webpack_public_path__ + "static/media/Background_00180.b39dcad1.png";